import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/components/modals/ConfirmDialog';
import { formatQuoteMessage } from './quote-message';
import type { QuotedStart } from './useQuotedStart';

interface StartQuoteConfirmDialogProps {
  dialog: QuotedStart | null;
  /** Запуск одной открытой записи или выбранного в списке — от этого зависит
   * заголовок: открытая запись не «выбранное». */
  kind: 'single' | 'selection';
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonTestId?: string;
}

/**
 * Подтверждение ручного запуска с уже посчитанной ценой. Открывается только
 * после ответа `quoteStart` (useQuotedStart), поэтому confirmDisabled не
 * нужен: окна «диалог открыт, а суммы ещё нет» здесь не бывает.
 */
export function StartQuoteConfirmDialog({
  dialog,
  kind,
  onClose,
  onConfirm,
  confirmButtonTestId,
}: StartQuoteConfirmDialogProps) {
  const { t } = useTranslation(['records', 'common']);

  const message = useMemo(
    () => (dialog ? formatQuoteMessage(t, 'records.start', dialog.quote) : ''),
    [dialog, t]
  );

  if (!dialog) return null;

  return (
    <ConfirmDialog
      isOpen
      onClose={onClose}
      onConfirm={onConfirm}
      title={
        kind === 'single'
          ? t('records.start.confirmTitleSingle')
          : t('records.start.confirmTitle')
      }
      message={message}
      confirmText={t('records.start.confirmAction')}
      cancelText={t('common:common.cancel')}
      variant="info"
      confirmButtonTestId={confirmButtonTestId}
    />
  );
}
